<template>
<div class="preloader">
  <div class="preloader__loader"></div>
</div>
</template>

<script>
export default {
  name: 'loader',
  props: {
    text: {
      default: '',
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>

.preloader {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-width: 180px;
  min-height: 180px;
  &__loader {
    display: block;
    position: relative;
    left: 50%;
    top: 50%;
    width: 150px;
    height: 150px;
    margin: -75px 0 0 -75px;
    border-radius: $--border-radius-circle;
    border: 5px solid transparent;
    border-top-color: $--color-primary;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
    &:before {
      content: "";
      position: absolute;
      top: 5px;
      left: 5px;
      right: 5px;
      bottom: 5px;
      border-radius: $--border-radius-circle;
      border: 5px solid transparent;
      border-top-color: $--color-secondary;
      -webkit-animation: spin 3s linear infinite;
      animation: spin 3s linear infinite;
    }
    &:after {
        content: "";
        position: absolute;
        top: 15px;
        left: 15px;
        right: 15px;
        bottom: 15px;
        border-radius: $--border-radius-circle;
        border: 5px solid transparent;
        border-top-color: $--color-tertiary;
        -webkit-animation: spin 1.5s linear infinite;
        animation: spin 1.5s linear infinite;
    }
  }
  &__text {
    text-align: center;
  }
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
